import { Routes } from '@angular/router';
import { Login } from './components/login/login';
import { UserRole } from './models/user.model';
import { RoleGuard } from './guards/role-guard';
import { AuthGuard } from './guards/auth-guard';
import { MFALogin } from './components/mfalogin/mfalogin';
import { SetupMFA } from './components/setup-mfa/setup-mfa';
import { Accesslocked } from './components/accesslocked/accesslocked';

export const routes: Routes = [
  { path: '', redirectTo: '/login', pathMatch: 'full' },
  { path: 'login', component: Login },
  { path: 'MFALogin', component: MFALogin },
  { path: 'SetupMFA', component: SetupMFA },
  { path: 'Accesslocked', component: Accesslocked },

  // Admin module - lazy loaded
  {
    path: 'admin',
    canActivate: [AuthGuard, RoleGuard],
    data: { roles: [UserRole.ADMIN] },
    loadChildren: () =>
      import('./components/admin/admin.routes').then(m => m.ADMIN_ROUTES)
  },

  // Teacher module - lazy loaded
  {
    path: 'teacher',
    canActivate: [AuthGuard, RoleGuard],
    data: { roles: [UserRole.TEACHER] },
    loadChildren: () =>
      import('./components/teacher/teacher.routes').then(m => m.TEACHER_ROUTES)
  },

  { path: '**', redirectTo: '/login' }
];
